import { render, staticRenderFns } from "./TerminosYCondicionesText.vue?vue&type=template&id=0f626aae&"
import script from "./TerminosYCondicionesText.vue?vue&type=script&lang=js&"
export * from "./TerminosYCondicionesText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardText } from 'vuetify/lib/components/VCard';
installComponents(component, {VCardText})
